import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';
import store from '@/assets/common/store/store';


interface Plant {
    id: string;
    name: string;
    show: boolean;
    show1: boolean;  
    show2: boolean; 
    crops: {
      id: string; 
      name: string;
    };
    cultivationPlan: {
      workStart: Date;
      workEnd: Date;
    };
  }

  interface Planting {
    id: string;
    name: string;
    crop: Crop;
    work_start_date: string | null;
    work_end_date: string | null;
  }

  interface Crop {
    id: string;
    name: string;
    phonetic: string;
    show: boolean;
    years?: Array<Year>
  }

  interface Year {
      year: string;
      show: boolean;
      plantings?: Array<DisplayItem>
    }

  interface DisplayItem {
    cropId: string;
    cropName: string;
    cropPhonetic: string;
    plantingId: string;
    plantingName: string;
    years: Array<string> | null;
    workingStart: string | null;
    workingEnd: string | null;
}

@Component({
    components: {
        SelectPlanting
    }
})
export default class PlantingList extends Vue {  
    @Prop({ default: null })
    private id!: string

    private search = '';
    private cropsTabActive = true;
    private yearsTabActive = false;
    private activeList: 'CROPS' | 'YEARS' = 'CROPS'
    private term: string[] = []
    private years: string[] = []

    private cropList: Array<Crop> = []
    private yearList: Array<Year | null> = []
    private plantingList: Array<DisplayItem> = new Array<DisplayItem>()
    private allItems: Array<DisplayItem> = []
    private baseUrl = '/master/plantings'
    private apiBaseUrl = '/plantings'
    private selectedCropId: string | null = null
    private selectedYear: string | null = null
    private selectedPlantingId: string | null = null
    private selectedPlanting: DisplayItem | null = null
    private cropAll: Crop = {
        id: '',
        name: 'すべて',
        phonetic: '',
        show: false
    }
    private openedCropList: Set<string> = new Set()
    private openedYearList: Set<string> = new Set()
    private isLoading = false
    private withHidden = false
    
    created() {
        this.$eventHub.$on('refresh-planting-list', (id: string) => {
            this.cropList = []
            this.allItems = []
            this.selectedPlantingId = id
            
            this.getPlantList()
        });
        this.selectedPlantingId = this.id
        this.getPlantList();
    }

    toggleHiddenItems() {
        this.withHidden = !this.withHidden
        this.cropList = []
        this.allItems = []
        this.getPlantList()
    }

    getPlantList() {
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.apiBaseUrl}?with_hidden=${this.withHidden}`)
        .then((res)=>{
            const plantings = res.plantings;
            this.loadedPlantList(plantings)

            plantings.forEach((planting: Planting)=>{
                const item: DisplayItem = {
                    cropId: planting.crop.id,
                    cropName: planting.crop.name,
                    cropPhonetic: planting.crop.phonetic,
                    plantingId: planting.id,
                    plantingName: planting.name,
                    years: this.getYears(planting.work_start_date, planting.work_end_date),
                    workingStart: planting.work_start_date,
                    workingEnd: planting.work_end_date
                }
                this.allItems.push(item)
                if(this.selectedPlantingId == item.plantingId) {
                    this.selectedPlanting = item
                    this.selectedCropId = item.cropId
                }
            })
            this.init()
        })
        .finally(() => {
            this.isLoading = false
        })
    }
    cropsToggle(crop: Crop) {
        crop.show = !crop.show;
        if(this.isOpenedCrops(crop.id)) {
            this.openedCropList.delete(crop.id)
        } else {
            this.openedCropList.add(crop.id)
        }
    }
    isOpenedCrops(cropId: string): boolean {
        return this.openedCropList.has(cropId)
    }
    yearsToggle(year: Year, crop: Crop) {
        year.show = !year.show;
        const selectYear = crop.id + year.year
        if(this.isOpenedYear(selectYear)) {
            this.openedYearList.delete(selectYear)
        } else {
            this.openedYearList.add(selectYear)
        }
        this.cropList = this.cropList.concat()
    }
    yearsToggleOnYear(year: Year) {
        year.show = !year.show;
        const selectYear = year.year
        if(this.isOpenedYear(selectYear)) {
            this.openedYearList.delete(selectYear)
        } else {
            this.openedYearList.add(selectYear)
        }
    }
    isOpenedYear(year: string): boolean {
        return this.openedYearList.has(year)
    }
    isActiveYear(cropId: string, year: string) {
        const plantings = this.searchPlantingList(cropId, year)
        const idList = plantings.map(p => p.plantingId)
        return idList.includes(this.selectedPlantingId ? this.selectedPlantingId : '')
    }
    modeChange(){
        this.$router.push(this.baseUrl, () => {return})
        if(store.getters.isInputChanged==false){
        const mode = 'add'
        this.selectedCropId = null
        this.selectedYear = null
        this.selectedPlantingId = null
        this.$eventHub.$emit('modeChange', mode);
        }
    } 
    edit(planting: DisplayItem, year: string) {
        const mode = 'edit';
        const plantingId = planting.plantingId
        this.$router.push(this.baseUrl + '/' + plantingId, () => {return})
        if(store.getters.isInputChanged==false){
        this.$eventHub.$emit('editTargetId', plantingId, mode);
        this.selectedCropId = planting.cropId
        this.selectedYear = planting.cropId + year
        this.selectedPlantingId = plantingId
        }

    }

    @Watch('search')
    doSearch() {
        this.init()
    }

    @Emit('getPlantings')
    loadedPlantList(list: Array<Plant>) {
        return list.map(item=>item.name)
    }

    init() {
        const filteredByKeyword = this.filterList(this.allItems, '', '', this.search)
        if(this.activeList === 'CROPS') {
            this.cropList = this.createCropList(filteredByKeyword)
            this.cropList.forEach((crop)=>{
                const years = this.searchYearList(crop.id)
                crop.years = years
                years.forEach((year)=>{
                    year.plantings = this.searchPlantingList(crop.id, year.year)
                })
            })
        } else {
            this.yearList = this.createYearList(filteredByKeyword, '')
        }
    }
    
    searchYearList(cropId: string): Array<Year> {
        const filteredByCrops = this.filterList(this.allItems, cropId, '', this.search)
        return this.createYearList(filteredByCrops, cropId)
    }

    searchPlantingList(cropId: string, year: string) {
        const filteredByYear = this.filterList(this.allItems, cropId, year, this.search)
        return this.createPlantingList(filteredByYear)
    }
    
    filterList(beforeArray: Array<DisplayItem>, cropId: string, year: string, searchKeyword: string): Array<DisplayItem>{
        let filteredItems: Array<DisplayItem> = []
        filteredItems = beforeArray.filter((item)=>{
            return (cropId == '' || cropId == item.cropId)
              && (year == '' || year == 'すべて' || item.years == null || item.years.indexOf(year) > -1)
              && (searchKeyword == '' || item.plantingName.indexOf(searchKeyword) > -1)
        })
        return filteredItems
    }

    createCropList(array: Array<DisplayItem>): Array<Crop> {
        let cropList = []

        const cropIdList = array.map((item)=> item.cropId)
        cropList = array.filter((item, index)=>{
            return cropIdList.indexOf(item.cropId) === index
        })
        .map((item)=>{
            let show = this.isOpenedCrops(item.cropId)
            if(this.selectedPlanting?.cropId == item.cropId) {
                show = true
                // this.selectedCropId = item.cropId
            }
            const crop = {
                id: item.cropId,
                name: item.cropName,
                phonetic: item.cropPhonetic,
                show: show
            }
            return crop
        })
        cropList = cropList.sort((a: Crop, b: Crop)=>this.compare(a.phonetic, b.phonetic))
        return cropList
    }

    createYearList(array: Array<DisplayItem>, cropId: string): Array<Year> {
        let yearList = []
        let allterm = false
        let selectedTerm = false
        let maxYear = 0
        let minYear = 0
        let yearSet: Set<string> = new Set()

        array.forEach((item: DisplayItem)=>{
            if (item.years != null) {
                item.years.forEach((year)=>{
                    const yearNum = Number(year)
                    if (maxYear == 0 || maxYear <= yearNum) {
                        maxYear = yearNum
                    }
                    if (minYear == 0 || minYear >= yearNum) {
                        minYear = yearNum
                    }
                    if(item.plantingId == this.selectedPlantingId) {
                        this.selectedYear = cropId + year
                    }
                    yearSet.add(year)
                })
                selectedTerm = true
            } else {
                allterm = true
            }
        })

        // 期間指定なしが含まれているときは最小年～最大年までの年を補間する
        if (allterm && selectedTerm) {
            yearSet = new Set()
            for (let i=minYear; i <= maxYear; i++) {
                yearSet.add(String(i))
            }
        }

        yearSet.add('すべて')
        yearList = Array.from(yearSet).map((item)=>{
            let show = this.isOpenedYear(cropId + item)
            if(this.selectedYear == cropId + item) {
                show = true
            }
            const year: Year = {
                year: item,
                show: show
            }
            return year
        }).sort((a, b) =>this.compare(Number(a.year), Number(b.year), true))
        if(this.selectedPlanting?.cropId == cropId && this.selectedPlanting?.years == null) {
            yearList[0].show = true
            this.selectedYear = cropId + yearList[0].year
        }
        return yearList
    }

    createPlantingList(array: Array<DisplayItem>): Array<DisplayItem> {
        this.plantingList = []
        
        return array.sort((a: DisplayItem, b: DisplayItem)=>this.compare(a.plantingName, b.plantingName))
    }

    compare(a: string | number | null, b: string | number | null, reverse?: boolean) {
        let comparison = 0;
        if(a == null) {
            return -1
        } else if(b == null) {
            return 1
        }
        
        if (a > b) {
            comparison = 1;
        } else if (a < b) {
            comparison = -1;
        }

        if (reverse == true) {
            // 降順ソート
            comparison = comparison * -1
        }

        return comparison;
    }

    getYears(workingStart: string | null, workingEnd: string | null): Array<string> | null {
        const array = []
        if(workingStart != null && workingEnd != null) {
            const start = Number(workingStart.substr(0, 4))
            const end = Number(workingEnd.substr(0, 4))
                
            for(let i=start; i <= end; i++ ) {
                array.push(String(i))
            }
            return array
        } else {
            return null
        }
    }
}